/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/catch-error-name */
/* eslint-disable camelcase */
/* eslint-disable radix */

export const inHouseJobsView = input => {
  try {
    const {
      job_id,
      job_company,
      job_title,
      job_contract,
      job_role,
      job_type,
      firm_name,
      firm_id,
    } = input
    analytics.track('in-house jobs - view', {
      eventCategory: 'post-user acquisition',
      eventAction: 'in-house jobs - view',
      eventLabel: 'submit',
      job_id,
      job_company,
      job_title,
      job_contract,
      job_role,
      job_type,
      firm_name,
      firm_id,
    })
  } catch (e) {
    console.log('Track: inHouseJobsView', e)
  }
}

export const inHouseJobsInterested = input => {
  try {
    const {
      job_id,
      job_company,
      job_title,
      job_pqe,
      job_contract,
      job_role,
      job_address,
      job_type,
      firm_name,
      firm_id,
    } = input
    analytics.track('in-house jobs - interested', {
      eventCategory: 'post-user acquisition',
      eventAction: 'in-house jobs - interested',
      eventLabel: 'submit',
      job_id,
      job_company,
      job_title,
      job_pqe,
      job_contract,
      job_role,
      job_address,
      job_type,
      firm_name,
      firm_id,
    })
  } catch (e) {
    console.log('Track: inHouseJobsInterested', e)
  }
}

;(function module() {
  angular.module('app.ui.form.ctrls').controller('InHouseJobsController', [
    'SharedApi',
    'InHouseJobsApi',
    '$window',
    '$translate',
    'logger',
    'usSpinnerService',
    '$location',
    '$scope',
    'practiceAreaService',
    'locationsGenericService',
    '$timeout',
    '$anchorScroll',
    'CandidateProfileApi',
    'userService',
    'socket',

    function controller(
      SharedApi,
      InHouseJobsApi,
      $window,
      $translate,
      logger,
      usSpinnerService,
      $location,
      $scope,
      practiceAreaService,
      locationsGenericService,
      $timeout,
      $anchorScroll,
      CandidateProfileApi,
      userService,
      socket
    ) {
      $translate.use('en')

      let vm = this
      socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', async data => {
        $timeout(() => {
          if (vm.user.id === data && $location.url().contains('inhouse-jobs')) {
            vm.initializeInHouseJobs()
          }
        }, 2000)
      })

      socket.on('CANDIDATE_RECOMMENDATION_GENERATED', async candidateId => {
        $timeout(() => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('inhouse-jobs')
          ) {
            vm.select(vm.currentPage)
          }
        }, 1500)
      })
      vm.candidateExternalMatchesData = []
      vm.currentPage = 1
      vm.noJob = false
      vm.selectedPracticeArea = undefined
      vm.selectedLocations = undefined
      vm.minPqe = undefined
      vm.maxPqe = undefined
      vm.candidateLocations = []
      vm.candidateSpecialties = []
      vm.fetchHiddenJobs = false
      vm.numPerPageOpt = [10, 20, 50]
      vm.numPerPage = vm.numPerPageOpt[2]
      vm.totalPositions = 0
      vm.countRefreshReq = false
      vm.today = new Date()
      vm.picSrc = 'images/firm-logo-default.jpg'
      vm.hideJobFilterButton = false
      vm.toolTipText = 'You have already shared your profile.'
      vm.pageName = 'in-house'
      vm.filterPQE = '0;11'

      vm.options = {
        round: 1,
        from: 0,
        to: 11,
        step: 0.5,
        dimension: '+ PQE',
        scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+'],
      }
      vm.spinnerActive = false
      vm.alertOne =
        'Unfortunately there are no current opportunities on LexStep for which your profile is a relevant match.  You will be alerted when a relevant opportunity match arises.  You can also edit your '
      vm.alertTwo =
        ' to refine your search parameters and reveal potential opportunities.'
      vm.startSpin = () => {
        if (!vm.spinnerActive) {
          usSpinnerService.spin('spinner-2')
          vm.spinnerActive = true
        }
      }

      vm.stopSpin = () => {
        if (vm.spinnerActive) {
          usSpinnerService.stop('spinner-2')
          vm.spinnerActive = false
        }
      }

      vm.getCandidateExternalMatchesData = async (id, payload) => {
        try {
          vm.startSpin()

          const {
            data: candidateExternalMatchesData,
          } = await InHouseJobsApi.getCandidateExternalMatchesData(id, payload)

          vm.candidateExternalMatchesData =
            candidateExternalMatchesData.positions
          vm.noJob = vm.candidateExternalMatchesData.length <= 0
          vm.positionsCount = candidateExternalMatchesData.positionsCount
          vm.totalPositions =
            vm.positionsCount.totalPositions - vm.positionsCount.hiddenPositions
          vm.hiddenPositions = vm.positionsCount.hiddenPositions

          vm.candidateExternalMatchesData.forEach(async position => {
            position.expanded = false
            vm.formatPositionDescription(position)
            vm.checkPositionIsNew(position)
            position.locations =
              position.locations.length > 0
                ? vm.locationsList
                    .filter(({id}) =>
                      position.locations.find(location => location === id)
                    )
                    .map(location => ({
                      name: location.name,
                      parent: location.parent,
                      color: location.country.region.color,
                    }))
                : []
          })
          vm.getAllEmployerLogos(vm.candidateExternalMatchesData)
          vm.applyFilterCheck = true

          vm.stopSpin()
          vm.disabledToolTip(vm.candidate)
          $scope.$applyAsync()
        } catch (error) {
          vm.stopSpin()
          logger.notify('error', `something went wrong: ${error.statusText}`)
        }
      }

      vm.select = async page => {
        vm.currentPage = page

        const payload = {
          limit: vm.numPerPage,
          page: page,
          hiddenPositions: vm.fetchHiddenJobs,
          practiceAreas: vm.selectedPracticeArea
            ? vm.selectedPracticeArea.length > 0
              ? vm.selectedPracticeArea.map(({id}) => id)
              : [0]
            : undefined,
          locations: vm.selectedLocations
            ? vm.selectedLocations.length > 0
              ? vm.selectedLocations.map(({id}) => id)
              : [0]
            : undefined,
          minPqe: vm.minPQE,
          maxPqe: vm.maxPQE,
          employerTypes: [54],
        }

        await vm.getCandidateExternalMatchesData(vm.user.id, payload)
      }

      vm.hidePositionFromUI = position => {
        position.isHidden = true
        vm.hiddenPositions++
        vm['jobRow' + position.id] = 'zoomOutRight'

        try {
          analytics.track('Selected Job Not For Me', {
            lawyer_id: vm.user.id,
            job_id: position.id,
            job_title: position.title,
            job_max_pqe: position.lawPreferences.maxPqe,
            job_min_pqe: position.lawPreferences.minPqe,
            job_contract: position.contractTypeName,
            job_role: position.occupationName,
            employer_type:
              position.employerTypes && position.employerTypes.length > 0
                ? position.employerTypes[0].name
                : undefined,
            firm_id: position.employerId,
            firm_name: position.employer.name,
            page: 'In-House',
          })
        } catch (error) {
          console.error('In-House', error)
        }

        $timeout(() => {
          vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(
            ({id}) => id !== position.id
          )

          vm.noJob = vm.candidateExternalMatchesData.length <= 0
          vm.totalPositions--
          vm.countRefreshReq = true
          vm['jobRow' + position.id] = ''
        }, 500)
      }

      vm.hideEmployerFromUI = position => {
        position.expanded = false
        const hiddenEmployerPositions = vm.candidateExternalMatchesData.filter(
          ({employerId}) => employerId === position.employerId
        )
        hiddenEmployerPositions.forEach(hiddenEmployerPosition => {
          vm['jobRow' + hiddenEmployerPosition.id] = 'zoomOutRight'
        })
        try {
          analytics.track('Selected Firm Not For Me', {
            lawyer_id: vm.user.id,
            employer_type:
              position.employerTypes && position.employerTypes.length > 0
                ? position.employerTypes[0].name
                : undefined,
            firm_id: position.firm_ID,
            firm_name: position.firm_Name,
            page: 'In-House',
          })
        } catch (e) {
          console.error('In-House', e)
        }

        $timeout(() => {
          hiddenEmployerPositions.forEach(hiddenEmployerPosition => {
            vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(
              ({id}) => id !== hiddenEmployerPosition.id
            )
            vm['jobRow' + hiddenEmployerPosition.id] = ''
          })

          vm.noJob = vm.candidateExternalMatchesData.length <= 0
          vm.totalPositions =
            Number.parseInt(vm.totalPositions) -
            Number.parseInt(hiddenEmployerPositions.length)
          vm.hiddenPositions =
            Number.parseInt(vm.hiddenPositions) +
            Number.parseInt(hiddenEmployerPositions.length)
          vm.countRefreshReq = true
        }, 500)
      }

      vm.unHidePosition = async position => {
        if (position.employerHidden && !position.positionHidden) {
          const payload = {
            employerIds: [Number.parseInt(position.employerId)],
            updateValue: false,
          }
          try {
            await InHouseJobsApi.unHideCandidateEmployer(
              position.userId,
              payload
            )
            vm.candidateExternalMatchesData.forEach(candidateExternalMatch => {
              if (candidateExternalMatch.employerId === position.employerId) {
                candidateExternalMatch.employerHidden = false
              }
            })
            position.expanded = false
            const unHiddenEmployerPositions = vm.candidateExternalMatchesData.filter(
              externalMatch =>
                externalMatch.employerId === position.employerId &&
                !externalMatch.positionHidden
            )
            unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
              vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft'
            })
            $scope.$apply()

            $timeout(() => {
              unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
                vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(
                  ({id}) => id !== unHiddenEmployerPosition.id
                )
                vm['jobRow' + unHiddenEmployerPosition.id] = ''
              })

              vm.noJob = vm.candidateExternalMatchesData.length <= 0
              vm.totalPositions =
                Number.parseInt(vm.totalPositions) +
                Number.parseInt(unHiddenEmployerPositions.length)
              vm.hiddenPositions =
                Number.parseInt(vm.hiddenPositions) -
                Number.parseInt(unHiddenEmployerPositions.length)
              vm.countRefreshReq = true
            }, 500)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'
            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        } else if (!position.employerHidden && position.positionHidden) {
          const payload = {
            positionIds: [Number.parseInt(position.id)],
            hide: false,
            reason: ' ',
          }
          try {
            await InHouseJobsApi.unHideCandidatePosition(
              position.userId,
              payload
            )
            position.isHidden = true
            vm.totalPositions++
            vm['jobRow' + position.id] = 'zoomOutLeft'
            $scope.$apply()
            $timeout(() => {
              vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(
                ({id}) => id !== position.id
              )
              vm.noJob = vm.candidateExternalMatchesData.length <= 0
              vm.hiddenPositions--
              vm.countRefreshReq = true
              vm['jobRow' + position.id] = ''
            }, 500)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'

            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        } else if (position.employerHidden && position.positionHidden) {
          const positionUnHidePayLoad = {
            positionIds: [Number.parseInt(position.id)],
            hide: false,
            reason: ' ',
          }
          const employerUnHidePayLoad = {
            employerIds: [Number.parseInt(position.employerId)],
            updateValue: false,
          }
          try {
            await InHouseJobsApi.unHideCandidatePosition(
              position.userId,
              positionUnHidePayLoad
            )
            await InHouseJobsApi.unHideCandidateEmployer(
              position.userId,
              employerUnHidePayLoad
            )
            vm.candidateExternalMatchesData.forEach(candidateExternalMatch => {
              if (candidateExternalMatch.employerId === position.employerId) {
                candidateExternalMatch.employerHidden = false
              }
            })
            position.isHidden = true
            const unHiddenEmployerPositions = vm.candidateExternalMatchesData.filter(
              externalMatch =>
                externalMatch.employerId === position.employerId &&
                !externalMatch.positionHidden
            )
            unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
              vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft'
            })
            vm['jobRow' + position.id] = 'zoomOutLeft'
            $scope.$apply()
            $timeout(() => {
              vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(
                ({id}) => id !== position.id
              )

              unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
                vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(
                  ({id}) => id !== unHiddenEmployerPosition.id
                )
                vm['jobRow' + unHiddenEmployerPosition.id] = ''
              })
              vm.noJob = vm.candidateExternalMatchesData.length <= 0
              vm.totalPositions =
                Number.parseInt(vm.totalPositions) +
                Number.parseInt(unHiddenEmployerPositions.length) +
                1
              vm.hiddenPositions =
                Number.parseInt(vm.hiddenPositions) -
                Number.parseInt(unHiddenEmployerPositions.length) -
                1
              vm.countRefreshReq = true
              vm['jobRow' + position.id] = ''
            }, 500)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'

            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        }
      }

      vm.redirectToAtsLink = position => {
        const {maxPqe, minPqe} = position
        let positionPqe =
          minPqe <= 0
            ? 'NQ'
            : minPqe + maxPqe === 11
            ? '+'
            : maxPqe <= 0 || maxPqe === minPqe
            ? ''
            : '-' + maxPqe

        inHouseJobsInterested(
          position.id,
          position.employer.name,
          position.title,
          positionPqe,
          position.contractTypeName,
          position.occupationName,
          position.Address,
          position.type,
          vm.user.agent.name,
          vm.user.agent.id
        )

        // eslint-disable-next-line no-negated-condition
        let positionUrl = !position.externalUrl.match(/http/)
          ? 'http://'.concat(position.externalUrl)
          : position.externalUrl
        $window.open(positionUrl, '_blank')
      }

      vm.notify = (type, message) => {
        // eslint-disable-next-line default-case
        switch (type) {
          case 'info':
            logger.log(message)
            break
          case 'success':
            logger.logSuccess(message)
            break
          case 'warning':
            logger.logWarning(message)
            break
          case 'error':
            logger.logError(message)
        }
      }

      vm.disabledToolTip = candidate => {
        if (candidate.approvalStatus === 'Locked')
          vm.toolTipText =
            'Your profile is locked, wait for reapproval to apply for jobs.'
        else if (
          candidate.user.phone &&
          !(!candidate.user.phone || candidate.user.phone === '')
        )
          vm.toolTipText = 'Upload your CV to connect with employers.'
        else if (!candidate.user.phone || candidate.user.phone === '')
          vm.toolTipText =
            'Please add your contact number in order to connect with firms.'
        return true
      }

      vm.loadPrivateJobs = () => {
        $location.url('/matches')
      }

      vm.onExpandJob = position => {
        const {maxPqe, minPqe} = position
        let positionPqe =
          minPqe <= 0
            ? 'NQ'
            : minPqe + maxPqe === 11
            ? '+'
            : maxPqe <= 0 || maxPqe === minPqe
            ? ''
            : '-' + maxPqe

        inHouseJobsView({
          job_id: position.id,
          job_company: position.employer.name,
          job_title: position.title,
          job_pqe: positionPqe,
          job_contract: position.contractTypeName,
          job_role: position.occupationName,
          firm_name: position.employer.name,
          firm_id: position.employer.id,
        })
      }

      vm.getAllEmployerLogos = inHousePositions => {
        inHousePositions.map(async inHousePositions => {
          const {employer} = inHousePositions
          if (employer.logo) {
            employer.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/employers/${inHousePositions.employerId}/logo/${employer.logo}`
            return employer
          }

          employer.logoSrc = vm.picSrc
          return employer
        })
        $scope.$apply()
      }

      vm.showJobs = position => {
        if (position.expanded) {
          position.expanded = false
        } else if (position.expanded === false) {
          position.expanded = true

          vm.onExpandJob(position)
        }
      }

      vm.onNumPerPageChange = async () => {
        await vm.select(1)
        vm.currentPage = 1
      }

      vm.hiddenJobFilter = async () => {
        if (vm.fetchHiddenJobs) {
          vm.fetchHiddenJobs = false
        } else {
          vm.fetchHiddenJobs = true
        }

        await vm.select(1)
      }

      vm.OnChangePracticeArea = async (event, selectedPracticeArea) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.selectedPracticeArea = selectedPracticeArea
          if (vm.selectedPracticeArea) {
            try {
              analytics.track('Practice Areas Filter Selected', {
                // eslint-disable-next-line camelcase
                lawyer_id: vm.user.id,
                // eslint-disable-next-line camelcase
                filtered_practice_area: vm.selectedPracticeArea.name,
                page: 'In-House',
              })
            } catch (error) {
              console.error('In-House', error)
            }

            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false
          }
        }
      }

      vm.onChangeLocation = async (event, selectedLocations) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.selectedLocations = selectedLocations
          if (vm.selectedLocations) {
            try {
              analytics.track('Practice Areas Filter Selected', {
                // eslint-disable-next-line camelcase
                lawyer_id: vm.user.id,
                // eslint-disable-next-line camelcase
                filtered_location: vm.selectedLocations.name,
                page: 'In-House',
              })
            } catch (error) {
              console.error('In-House', error)
            }

            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false
          }
        }
      }

      vm.pqeChanged = async () => {
        let separator = vm.filterPQE.search(';')
        let minPQE = vm.filterPQE.slice(0, separator)
        let maxPQE = vm.filterPQE.slice(separator + 1, vm.filterPQE.length)
        vm.minPQE = minPQE
        vm.maxPQE = maxPQE

        try {
          analytics.track('PQE Filter Selected', {
            // eslint-disable-next-line camelcase
            lawyer_id: vm.user.id,
            // eslint-disable-next-line camelcase
            min_pqe: minPQE,
            // eslint-disable-next-line camelcase
            max_pqe: maxPQE,
            page: 'In-House',
          })
        } catch (error) {
          console.error('In-House', error)
        }

        await vm.select(vm.currentPage)
        vm.applyFilterCheck = false
      }

      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.loadPrivateJobs = () => {
        $location.url('/matches')
      }

      vm.formatJobs = position => {
        position.isCollapsed = true
        position.moreDetail = true
        if (position.description !== null) {
          if (position.description.length > 600) {
            position.showButton = true
          }
        }
      }

      vm.showMore = job => {
        job.isCollapsed = !job.isCollapsed
      }

      vm.jumpToLink = id => {
        var oldHash
        oldHash = $location.hash()
        $location.hash(id)
        $anchorScroll()
        $location.hash(oldHash)
      }

      vm.showLess = job => {
        job.isCollapsed = !job.isCollapsed
        vm.jumpToLink(job.id)
      }

      vm.formatPositionDescription = position => {
        position.isCollapsed = true
        position.moreDetail = true
        if (position.description !== null) {
          if (position.description.length > 600) {
            position.showButton = true
          }
        }
      }

      vm.checkPositionIsNew = position => {
        const timeDiff = Math.abs(
          vm.today.getTime() - new Date(position.created).getTime()
        )

        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        if (diffDays < 7) {
          position.isNewJob = true
        }
      }

      vm.locationBackgroundColor = color => {
        if (color) {
          return {
            background: color,
          }
        }
      }

      vm.updateProfileAlertStatus = (alertType, status) => {
        if (alertType === 'both') {
          vm.candidate.profileCvAlertCollapsed = status
          vm.candidate.profilePhoneAlertCollapsed = status
        } else {
          vm.candidate[alertType] = status
        }
      }

      vm.initializeInHouseJobs = async () => {
        const user = await userService.getUser()
        vm.user = user
        const {data: locationsList} = await SharedApi.getAllLocations({
          supported: true,
          regions: true,
        })
        vm.locationsList = locationsList

        const {data: candidate} = await CandidateProfileApi.getUserProfile(
          user.id,
          {
            include: ['occupations', 'preferredContractTypes'],
          }
        )
        vm.candidate = candidate

        const {data} = await CandidateProfileApi.getUserProfile(user.id, {
          include: ['preferredLocations'],
        })
        vm.candidate.preferredLocations = data.preferredLocations
        const {data: legalPracticeAreaList} = await SharedApi.getCategoryById(1)
        vm.legalPracticeAreaList = legalPracticeAreaList

        vm.candidateSpecialties = practiceAreaService.makeCandidatePracticeAreasHierarchy(
          candidate.category,
          vm.legalPracticeAreaList.specialties
        )

        vm.regionHierarchialListWithEuropeOnTop = locationsGenericService.makeCandidateLocationsHierarchy(
          vm.candidate.preferredLocations,
          vm.locationsList
        )

        vm.curLawyer = {
          user: {
            firstName: vm.user.firstName,
          },
          candidate: {
            profileCvAlertCollapsed: false,
            profilePhoneAlertCollapsed: false,
          },
        }
        await vm.onNumPerPageChange()
        $scope.$applyAsync()
      }

      vm.initializeInHouseJobs()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/inhouse-jobs/in-house-jobs.ctrl.js